import logger from "redux-logger";
import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import { persistStore } from "redux-persist";
import voiceChatMiddleware from "./app/ai/voice/middleware/voiceChatMiddleware";
import vapiMiddleware from "./app/ai/duck/middleware";

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose;
let middleware;
middleware = applyMiddleware(thunk, voiceChatMiddleware, vapiMiddleware);
const composedEnhancers = composeEnhancers(middleware);
const store = createStore(rootReducer, composedEnhancers);
export const persistor = persistStore(store);
export default store;
